import axios from 'axios';

const API_BASE_URL = 'https://izttvhkaqp.us-east-1.awsapprunner.com';

// Axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Optional: global error logging (recommended)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('❌ API Error:', error.response?.data || error.message);
    if (error.response?.data?.detail) {
      console.error('❌ Validation Errors:', error.response.data.detail);
    }
    return Promise.reject(error);
  }
);

export const apiService = {
  // ===============================
  // USER MANAGEMENT
  // ===============================

  // Signup (creates user if not exists, optionally saves test result)
  // signup: async (
  //   email,
  //   fullName,
  //   isStudent,
  //   isWorkingProfessional,
  //   testResult = null,
  //   uniqueUserName = null,
  //   institutionName = null,
  //   fieldOfStudy = null,
  //   yearsOfExperience = null,
  //   domainOfWork = null
  // ) => {
  //   console.log('🟣 signup - Email:', email, 'Full Name:', fullName, 'Is Student:', isStudent, 'Is Working Professional:', isWorkingProfessional);
  //   const body = {
  //     email,
  //     full_name: fullName,
  //     is_student: isStudent,
  //     is_working_professional: isWorkingProfessional,
  //   };
    
  //   // Add optional fields
  //   if (uniqueUserName) body.unique_user_name = uniqueUserName;
  //   if (institutionName) body.institution_name = institutionName;
  //   if (fieldOfStudy) body.field_of_study = fieldOfStudy;
  //   if (yearsOfExperience !== null) body.years_of_experience = yearsOfExperience;
  //   if (domainOfWork) body.domain_of_work = domainOfWork;
  //   if (testResult) body.test_result = testResult;
    
  //   console.log('🟣 signup - Request body:', body);
    
  //   const { data } = await api.post('/api/user/signup', body);
  //   console.log('🟣 signup - Response:', data);
  //   return data;
  // },

  signup: async (payload) => {
  console.log('🟣 signup - Payload received:', payload);

  const { data } = await api.post('/api/user/signup', payload);

  console.log('🟣 signup - Response:', data);
  return data;
},


  // Login existing user
  login: async (email) => {
    console.log('🟣 login - Email:', email);
    const { data } = await api.post('/api/user/login', { email });
    console.log('🟣 login - Response:', data);
    return data;
  },

  // Fetch user test history
  getTestHistory: async (userId, limit = 20) => {
    console.log('🟣 getTestHistory - userId:', userId, 'limit:', limit);
    const { data } = await api.get(`/api/user/test-history/${userId}`, {
      params: { limit },
    });
    console.log('🟣 getTestHistory - Response:', data);
    return data;
  },

  // Save test result to user account (manual save after test)
  saveTestResult: async (userId, testResult) => {
    console.log('🟣 saveTestResult - userId:', userId, 'test result:', testResult);
    const { data } = await api.post('/api/user/save-test-result', {
      user_id: userId,
      test_result: testResult,
    });
    console.log('🟣 saveTestResult - Response:', data);
    return data;
  },

  // Fetch questions for a level
  getLevelQuestions: async (levelId, numQuestions = 5) => {
    console.log('🔵 getLevelQuestions - levelId:', levelId, 'numQuestions:', numQuestions);
    const { data } = await api.get(`/api/level/${levelId}/questions`, {
      params: { num_questions: numQuestions },
    });
    console.log('🔵 getLevelQuestions - Received', data.questions?.length, 'questions');
    return data;
  },

  // Submit answers for a level
  submitLevel: async (levelId, answers, timeTaken, userId = null) => {
    const body = {
      answers,
      time_taken: timeTaken
    };

    if (userId) {
      body.user_id = userId;
      console.log('🔵 submitLevel - Sending user_id:', userId, 'for level:', levelId);
    } else {
      console.log('⚪ submitLevel - No user_id (anonymous)');
    }

    const { data } = await api.post(`/api/level/${levelId}/submit`, body);
    return data;
  },

  // Final results (AUTO-SAVES when user_id is provided)
  getFinalResults: async (
    finalLevel,
    wrongQuestions,
    levelScores,
    allAnsweredQuestions,
    userId = null,
    moreDetails = null
  ) => {
    const body = {
      final_level: finalLevel,
      wrong_questions: wrongQuestions,
      level_scores: levelScores,
      all_answered_questions: allAnsweredQuestions,
    };

    if (userId) {
      body.user_id = userId;
      console.log('🔵 getFinalResults - Sending user_id:', userId, 'final_level:', finalLevel);
    } else {
      console.log('⚪ getFinalResults - No user_id (anonymous)');
    }

    if (moreDetails) {
      body.more_details = moreDetails;
      console.log('🔵 getFinalResults - Including more_details:', moreDetails);
    }

    console.log('🔵 getFinalResults - FULL REQUEST BODY:', JSON.stringify(body, null, 2));

    const { data } = await api.post('/api/final-results', body);
    return data;
  },

  // ===============================
  // STATS & META
  // ===============================

  // Global platform stats
  getStats: async () => {
    console.log('📊 getStats - Fetching global statistics');
    const { data } = await api.get('/api/stats');
    console.log('📊 getStats - Response:', data);
    return data;
  },

  // Update best performer name
  updateBestPerformanceName: async (userName) => {
    console.log('📊 updateBestPerformanceName - userName:', userName);
    const { data } = await api.post('/api/update-best-performance-name', {
      user_name: userName,
    });
    console.log('📊 updateBestPerformanceName - Response:', data);
    return data;
  },

  // Health check
  checkHealth: async () => {
    console.log('❤️ checkHealth - Pinging API');
    const { data } = await api.get('/health');
    console.log('❤️ checkHealth - Response:', data);
    return data;
  },

  // Submit user feedback
  submitFeedback: async (payload) => {
    console.log('🟣 submitFeedback - payload:', payload);
    // Endpoint corrected: backend expects /api/submit-feedback
    const { data } = await api.post('/api/submit-feedback', payload);
    console.log('🟣 submitFeedback - Response:', data);
    return data;
  },
};

export default api;
